import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=e238839a&scoped=true"
import script from "./answerDetail.vue?vue&type=script&lang=ts"
export * from "./answerDetail.vue?vue&type=script&lang=ts"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=e238839a&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e238839a",
  null
  
)

export default component.exports